import { useQuery } from "@tanstack/react-query";
import { getActivities } from "../api/timeEntryApi";
import { timeEntryKeys } from "../api/timeEntryKeys";

// Obtiene el catálogo de actividades de imputación.
// El parámetro `enabled` permite diferir la carga hasta que el dialog esté abierto.
export const useActivities = (enabled = true) =>
  useQuery({
    queryKey: timeEntryKeys.activities(),
    queryFn: getActivities,
    enabled,
  });
